import { AxiosResponse } from 'axios';
import { api } from '../providers/base-api';

export interface EpiRoundItemInput {
  employeeId?: number;
  epiId?: number;
  situation: string;
  observation?: string;
}

export interface CreateEpiRoundData {
  date: string;
  unit?: string;
  sector?: string;
  inspector?: string;
  notes?: string;
  items: EpiRoundItemInput[];
}

export interface EpiRoundItemDto {
  id: number;
  situation: string;
  observation?: string;
  employeeName: string;
  employeeId?: number;
  sector: string;
  epiName: string;
  epiId?: number;
}

export interface EpiRoundSummaryDto {
  id: number;
  date: string;
  unit?: string;
  sector?: string;
  inspector?: string;
  createdAt: string;
  itemCount: number;
  issueCount: number;
}

export interface EpiRoundDto {
  id: number;
  date: string;
  unit?: string;
  sector?: string;
  inspector?: string;
  notes?: string;
  createdAt: string;
  items: EpiRoundItemDto[];
}

export interface PaginatedEpiRounds {
  items: EpiRoundSummaryDto[];
  total: number;
}

export async function listEpiRoundsRequest(params?: {
  sector?: string;
  unit?: string;
  page?: number;
  limit?: number;
}): Promise<AxiosResponse<PaginatedEpiRounds>> {
  return api.get<PaginatedEpiRounds>('/epi-rounds', { params });
}

export async function showEpiRoundRequest(
  id: number,
): Promise<AxiosResponse<EpiRoundDto>> {
  return api.get<EpiRoundDto>(`/epi-rounds/${id}`);
}

export async function createEpiRoundRequest(
  data: CreateEpiRoundData,
): Promise<AxiosResponse<void>> {
  return api.post<void>('/epi-rounds', data);
}

export async function updateEpiRoundRequest(
  id: number,
  data: Partial<CreateEpiRoundData>,
): Promise<AxiosResponse<void>> {
  return api.patch<void>(`/epi-rounds/${id}`, data);
}

export async function deleteEpiRoundRequest(
  id: number,
): Promise<AxiosResponse<void>> {
  return api.delete<void>(`/epi-rounds/${id}`);
}

export async function listPendingEpiRoundItemsRequest(): Promise<
  AxiosResponse<any[]>
> {
  return api.get<any[]>('/epi-rounds/pending');
}
